import React from 'react';
import ReactDOM from 'react-dom';

import App from './components/App';
import AppInitWrapper from './components/AppInitWrapper';

ReactDOM.render(
  <React.StrictMode>
    <AppInitWrapper>
      <App />
    </AppInitWrapper>
  </React.StrictMode>,
  document.getElementById('root')
);
